<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/xinshen.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li class="special" v-for="(item, index) in navList" :key="index" :class="{ hover: cut === item.id }"
          @click="navClick(index, item.name)" @mouseover="cut = item.id">
          <span class="sb" @click="$router.push(item.path)">
            {{ item.name }}
            <span v-if="Array.isArray(item.children) && item.children.length > 0"
              class="glyphicon glyphicon-menu-down"></span>
          </span>
        </li>
      </ul>
      <Lang class="right-menu-item"></Lang>
      <div v-if="cut === 2" class="tip_product" @mouseleave="cut = 7">
        <div style="display: flex;justify-content: space-evenly">
          <div class="col">
            <div class="uol">
              <div class="built" @click="$router.push('/software/big')"><i class="iconfont" style="width: 24px">&#xe627;</i>{{
                $t('prod.save') }}</div>
              <ul>
                <li @click="$router.push('/software/big?index=0')">{{ $t('Product.pro') }}</li>
                <li @click="$router.push('/software/big?index=1')">{{ $t('Product.pro1') }}</li>
                <li @click="$router.push('/software/big?index=2')">{{ $t('Product.pro2') }}</li>
                <li @click="$router.push('/software/big?index=3')">{{ $t('Product.pro3') }}</li>
                <li @click="$router.push('/software/big?index=4')">{{ $t('Product.pro4') }}</li>
                <li @click="$router.push('/software/big?index=5')">{{ $t('Product.pro5') }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <img class="header-img-m" src="">
        <div class="header-nav-m-menu-wrapper" @click="menu">
          <div style="border: 1px solid white;display: inline-block">
            <img src="../assets/img/xl.png" style="display: block;width: 27px;height: 32px">
          </div>
        </div>
        <!-- 导航内容 -->
        <div v-if="menuClass === 1" class="nav-content">
          <ul class="header-nav-m-wrapper">
            <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
              @click="navClick(item)">
              <span style="padding: 0.8rem 0 0.8rem 1rem;">
                {{ item.name }}
              </span>
              <ul class="two" v-if="er === item.id">
                <li v-for="(ite, inde) in item.children" @click="dsb(ite)" :key="inde">{{ ite.name }}</li>
              </ul>
            </li>
          </ul>
          <Lang class="right-menu-item"></Lang>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "../router";
import Lang from "./Lang/index.vue";
export default {
  name: "Header",
  components: { Lang },
  computed: {
    navList() {
      return [
        {
          id: 0,
          name: this.$t('navbar.index'),
          path: "/",
          children: []
        },
        {
          id: 2,
          name: this.$t('navbar.center'),
          path: null,
          children: [
            {
              name: this.$t('prod.save'),
              route: '/soft'
            },
            {
              name: this.$t('prod.dd'),
              route: '/store'
            },
            {
              name: this.$t('prod.fz'),
              route: '/GENRE'

            },
          ]
        },
        {
          id: 3,
          name: this.$t('navbar.solve'),
          path: "/core",
          children: []
        },
        {
          id: 5,
          name: this.$t('navbar.about'),
          path: '/companyintroduction',
          children: [],
        },
        {
          id: 7,
          name: this.$t('navbar.advanced'),
          path: '/contactus',
          children: []
        },
      ]
    }
  },
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: 0,
      cut: 0,
      er: 0,
    };
  },
  methods: {
    router() {
      return router
    },
    dsb(ite) {
      this.menuClass = 0;
      this.$router.push(ite.route)
    },
    navClick(item) {
      if (item.path != null) {
        this.menuClass = 0;
        this.$router.push(item.path);
      } else {
        if (this.er !== 0) {
          this.er = 0;
        } else {
          this.er = item.id;
        }
      }
    },
    menu() {
      if (this.menuClass === 0) {
        this.menuClass = 1;
      } else {
        this.menuClass = 0;
        this.er = 0;
      }
    },
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  width: 100%;
  background-color: rgba(255,255,255,0.4);
  box-shadow: inset 0 -1px 0 0 rgba(255,255,255,0.19);
  transition: all ease 0.6s;
}

#header .header-top {
  height: 60px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 60px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 130px;
  height: 100%;
  float: left;
  position: relative;
}

/*导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 179px;
  height: 35px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 60px;
}

#header .header-nav .header-nav-wrapper {
  display: inline-block;
  line-height: 60px;
  margin-left: 15%;
  margin-bottom: 0 !important;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  padding: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>.sb {
  display: inline-block;
  height: 60px;
  line-height: 60px;
  color: #242933;
  font-size: 15px;
  font-weight: bold;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>.sb>span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>.sb:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper>li.active>a {
  text-decoration: none;
}
#header .header-nav .special{
  cursor: pointer;
}

#header .header-nav .special:nth-child(3).hover {
  /* background: #222222 !important; */
  border-right: 1px solid white;
  border-left: 1px solid white;
}

#header .header-nav .special:nth-child(5).hover {
  /* background: #222222 !important; */
  border-right: 1px solid white;
  border-left: 1px solid white;
}

#header .header-nav .special:nth-child(6).hover {
  /* background: #222222 !important; */
  border-right: 1px solid white;
  border-left: 1px solid white;
}

#header .header-nav .special:nth-child(3).hover .sb>span {
  transform: rotate(180deg);
}

#header .header-nav .special:nth-child(5).hover .sb>span {
  transform: rotate(180deg);
}

#header .header-nav .special:nth-child(6).hover .sb>span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  background: #ccc;
}

#header .right-menu-item {
  cursor: pointer;
  float: right;
  height: 60px;
  line-height: 60px;
}

#header .tip_product {
  max-width: 1170px;
  display: inline-table;
  position: absolute;
  z-index: 9999;
  border-left: 1px solid white;
  border-bottom: 1px solid white;
  border-right: 1px solid white;
  background: #FFFFFF;
  padding: 1.5rem !important;
  margin: 0 auto;
  top: 60px;
  bottom: 0;
  right: 0;
  left: 0;
}

#header .tip_product .col {
  display: flex;
  flex-wrap: wrap;
  width: 890px;
  border-right: 1px solid white;
}

#header .tip_product .col .uol {
  margin-right: 60px;
}

#header .tip_product .col .uol .built {
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
  color: #242933;
  line-height: 22px;
  margin-bottom: 21px;
}

#header .tip_product .col .uol .built i {
  padding: 0 4px;
}

#header .tip_product .col ul {
  list-style: disc !important;
  padding-left: 25px;
  display: flex;
  flex-direction: column;
  width: 180px;
}

#header .tip_product .col ul li {
  padding-left: 6px;
  cursor: pointer;
  line-height: 28px;
  border-bottom: 1px solid #D8D8D8;
  color: #242933;
  margin-bottom: 16px;
}

#header .tip_product .col ul li:hover {
  background: white;
  list-style: none;
  color: black;
}

#header .tip_product .menu {
  display: inline-block;
}

#header .tip_product .menu .tab_mg {
  text-align: center;
  color: #242933;
}

#header .tip_product .menu .tab_mg p {
  margin-top: 20px;
}

#header .tip_product .menu .button {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #242933;
}

#header .tip_product .menu .button .btn {
  padding: 8px 1.5rem;
  border: 1px solid white;
}

#header .tip_product .menu .button .btn:hover {
  background: white;
  color: black;
  cursor: pointer;
}


@media screen and (max-width: 1170px) {
  #header .col {
    width: auto !important;
  }
}

@media screen and (max-width: 1014px) {
  #header .right-menu-item {
    display: none !important;
  }

  #header .header-nav .header-nav-logo {
    width: 120px !important;
  }

  .col {
    width: auto !important;
  }
}

@media screen and (max-width: 768px) {
  #header .right-menu-item {
    display: block !important;
    margin: 0 auto;
    float: none;
  }

  #header .header-img-m {
    display: flex;
    margin: 0 auto;
    height: 100%;
  }

  #header .nav-content {
    position: fixed;
    z-index: 99998;
    padding-top: 20px;
    background: black;
    width: 100%;
    height: 100vh;
  }

  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: black;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 99998;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: relative;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    text-align: left;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }

  #header .two li {
    color: black;
    padding: 0.8rem 1rem;
    background: white;
    border-bottom: 1px #ddd solid;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue